// Centralized feature flags. Flip these to enable WIP modules.
// B2B (practitioner workspace) is intentionally OFF for the MVP.
export const FEATURE_B2B = false;

// Legacy single-tier flag — kept for compatibility, replaced by the
// Core / Pro split below. The Pro add-on covers a curated subset of
// "Suivi spécialisé" protocols (rosacea, mole ABCDE, hair density, etc.).
export const FEATURE_SPECIALIZED_PAID = false;

/**
 * Master switch for the paid "Suivi Pro" add-on UI (lock badges + upsell).
 * Even when false, Pro-tier protocols remain visible but locked — flipping
 * this to `true` enables the upsell modal & checkout wiring (Phase 1.5).
 */
export const FEATURE_TIER_PRO_ENABLED = true;

/**
 * Stripe price IDs that grant access to "Suivi Pro" protocols.
 * Keep this in sync with the prices created via payments--create_product
 * for the `protocols_pro` product (monthly + yearly).
 * Left empty until the prices are wired — server-side `isPro` check
 * returns false in that state.
 */
export const PRO_PRICE_IDS: string[] = [
  "protocols_pro_monthly",
  "protocols_pro_yearly",
];

/** Free trial duration (days) for the Suivi Pro add-on. */
export const PRO_TRIAL_DAYS = 7;

/** True when at least one Pro price is configured. */
export function isProBillingConfigured(): boolean {
  return PRO_PRICE_IDS.length > 0;
}

type EntitlementCtx = { isPremium: boolean; isPro: boolean };

/** Returns true if the user is allowed to start/open the given protocol. */
export function isProtocolUnlocked(
  protocol: { tier: "core" | "pro" },
  ctx: EntitlementCtx,
): boolean {
  if (protocol.tier === "core") return ctx.isPremium;
  return ctx.isPremium && ctx.isPro;
}

/** Maps an /app analysis goal to a recommended specialized protocol goal. */
export function suggestedProtocolForGoal(
  goal: "skin" | "weight" | "muscle" | "antiaging",
): "post_aesthetic" | "meno_andro" | "pre_post_op" | "onco_recovery" {
  switch (goal) {
    case "skin":
      return "post_aesthetic";
    case "antiaging":
    case "weight":
    case "muscle":
    default:
      return "meno_andro";
  }
}
